import { categoryNavigationImpressionsTracking, categoryNavigationClickTracking } from '../GTMEvents';

class CategoryPill {
  static navigationType = {
    pills: 'pill',
    'circle nav': 'circle',
  };

  constructor() {
    this.pod = document.querySelector('.category-pills__wrapper');
    this.pills = this.pod?.querySelectorAll('.category-pills__pill') || [];
    // it will point out to breadcrumbs
    this.collectionTitle =
      document.querySelector('[aria-labelledby="collection-title"] [aria-current]')?.textContent || '';
  }

  init() {
    if (!this.pod) return;

    setTimeout(() => {
      this.#bindEvents();
      this.#setObserverImpressions();
    }, 0);
  }

  /**
   * Initialize events
   */
  #bindEvents() {
    this.pills.forEach((pill) =>
      pill.addEventListener('click', (event) => {
        const anchor = event.target;

        // Defer this task because it is non-visibile user task
        // Keep in mind, category pills have this structure
        // <div data-type-category="something">
        //  <a href="collection-destination"></a>
        // </div>
        // From click perspective the access to data is a little different
        setTimeout(() => {
          categoryNavigationClickTracking({
            name: anchor.closest('div')?.dataset?.category || '',
            destination: anchor?.href || '',
            type: CategoryPill.navigationType[anchor.closest('div')?.dataset?.typeCategory.toLowerCase()] || '',
          });
        }, 0);
      }),
    );
  }

  /**
   * Initialize observer
   */
  #setObserverImpressions() {
    const pillCallback = (entries, observer) => {
      return entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const podNode = entry.target;
        // Keep in mind, category pills have this structure
        // <div data-type-category="something">
        //  <a href="collection-destination"></a>
        // </div>
        categoryNavigationImpressionsTracking({
          name: podNode.dataset?.category,
          destination: podNode.firstElementChild?.href || '',
          type: CategoryPill.navigationType[podNode.dataset?.typeCategory.toLowerCase()] || '',
        });

        observer.disconnect();
      });
    };

    this.pills.forEach((pill) =>
      new IntersectionObserver(pillCallback, { root: this.pod || null, rootMargin: '0px', threshold: 0.5 }).observe(
        pill,
      ),
    );
  }
}

export default CategoryPill;
